import React from "react";
import { Link } from "react-router-dom";
import SignInPresenter from "./SignInPresenter";
import { signInUseCase } from "../../usecases/user";
import { Button } from "nq-component";
import BasePage from "../../base/BasePage";
import withRouter from "../../withRouter";
import InputFactory from "../../components/InputFactory";
import Head from "../../components/head";
import PhishingAdvisoryModal from "../../components/PhishingAdvisoryModal";

class SignInPage extends BasePage {
  constructor() {
    super();
    this.presenter = new SignInPresenter(this, signInUseCase());
    this.state = { progress: false, isHovered: false };
    this.handleHover = this.handleHover.bind(this);
  }

  componentDidMount() {
    sessionStorage.removeItem("navigatingAway");
  }

  formSubmit(e) {
    e.preventDefault();
    this.presenter.submit();
  }

  getMasterKey() {
    return this.props.params && this.props.params.masterKey;
  }

  onChange(value, field) {
    this.presenter.onChange(value, field);
  }

  handleHover() {
    this.setState((prevState) => ({
      isHovered: !prevState.isHovered,
    }));
  }

  render() {
    return (
      <>
        <PhishingAdvisoryModal />
        <Head className="shadow-sm" />
        <div className="d-flex flex-column" style={{ minHeight: "100vh" }}>
          <div
            className="m-auto position-relative w-100 "
            style={{
              backgroundImage: `url(${process.env.PUBLIC_URL}/login-bg.png`,
              backgroundPosition: "50%",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            }}
          >
            <div className=" d-flex h-100">
              <div className="m-auto container d-flex p-3 p-lg-5 justify-content-center w-100">
                <div
                  className=" rounded  w-75"
                  style={{
                    background: "hsla(0, 0%, 100%, .77)",
                    border: "1px solid #e8e8e8",
                    padding: "24px",
                  }}
                >
                  <div className="row">
                    <div className="col-md-6">
                      <div className="h-100 d-flex align-items-center">
                        <div className="text-center p-3 w-100">
                          <h3 className="fw-bold " style={{ color: "#191c79" }}>
                            Welcome to HRIS!
                          </h3>
                          <p
                            style={{
                              margin: "20px 0",
                              color: "#333",
                              fontSize: "17px",
                            }}
                          >
                            Human Resource Information System
                          </p>
                          <p
                            style={{
                              margin: "50px 0 18px 0",
                              fontSize: "18px",
                            }}
                          >
                            FOR OFFICIAL USE ONLY
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 p-3 px-lg-5 py-lg-4">
                      <h3
                        className="fw-bold mb-3"
                        style={{
                          color: "#191c79",
                          fontWeight: "bold",
                          textAlign: "center",
                          paddingBottom: "1em",
                          borderBottom: "1px solid #ddd",
                        }}
                      >
                        Employee Login{" "}
                        <i
                          className="bi bi-lock"
                          style={{ color: "#191c79" }}
                        ></i>
                      </h3>
                      <form onSubmit={this.formSubmit.bind(this)}>
                        <div className="row g-3">
                          <div
                            className="col-md-12"
                            style={{ marginTop: "30px" }}
                          >
                            <label
                              className="form-label"
                              style={{ marginBottom: "18px", fontSize: "16px" }}
                            >
                              Email Address / Username
                            </label>
                            <InputFactory
                              required
                              type="String"
                              autoComplete="nope"
                              className="form-control"
                              placeholder="Email Address / Username"
                              field="username"
                              onChange={this.onChange.bind(this)}
                            />
                          </div>
                          <div className="col-md-12">
                            <label
                              className="form-label fs-sm"
                              style={{ marginBottom: "18px", fontSize: "16px" }}
                            >
                              Password
                            </label>
                            <InputFactory
                              type="Password"
                              required
                              className="form-control"
                              placeholder="Password"
                              field="password"
                              onChange={this.onChange.bind(this)}
                            />
                          </div>
                          <div className="text-end">
                            <div className="mb-3 text-end">
                              <Link
                                to="/forgot"
                                className="fs-sm ms-2"
                                style={{ color: "#169bd5" }}
                              >
                                Forgot Login Details?
                              </Link>
                            </div>
                          </div>
                          <div className="text-center">
                            <Button
                              progress={this.state.progress}
                              type="submit"
                              className="p-2 w-100"
                              style={{
                                backgroundColor: this.state.isHovered
                                  ? "#e2af2d"
                                  : "#29457c",
                                border: "none",
                                color: "#fff",
                                borderRadius: "5px",
                                transition: "background-color 0.3s ease",
                              }}
                              onMouseEnter={this.handleHover}
                              onMouseLeave={this.handleHover}
                            >
                              {this.state.progress ? "Please wait..." : "LOGIN"}
                            </Button>
                          </div>
                          {/* <div className="text-center">
                          <span className="fs-sm">
                            Don't have an account?
                            <Link to="/signup" className="ms-1">
                              <span className="text-decoration-underline">
                                Sign up
                              </span>
                            </Link>
                          </span>
                        </div> */}
                          <div className="text-center">
                            <p style={{ fontSize: "10px", color: "#7f7f7f" }}>
                              This is a private network of Bureau of
                              Immigration. Unauthorized access is prohibited.
                              Use of this application constitutes agreement to
                              this Privacy Policy and Terms of Service.
                            </p>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p
              style={{
                top: "95%",
                color: "#333",
                fontWeight: "bold",
                fontSize: "14px",
                position: "absolute",
                marginLeft: "2rem",
              }}
            >
              V.1.0.1
            </p>
          </div>
          <footer
            className="text-white text-center py-3"
            style={{
              marginTop: "auto",
              width: "100%",
              backgroundColor: "#22262a",
            }}
          >
            <div className="container">
              <div className="footer-content" style={{ fontSize: "14px" }}>
                <a
                  style={{
                    color: "white ",
                    borderBottom: "1px solid #fff",
                  }}
                  href="https://www.google.com/maps/dir//Bureau+of+Immigration+Head+Office+HXVG%2BR53+Magallanes+Dr+Intramuros,+Manila,+1002+Metro+Manila/@14.5945248,120.9754254,17z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3397ca17691abc91:0xb7622582aa396dce!2m2!1d120.9754254!2d14.5945248?entry=ttu"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Magallanes Drive, Intramuros, Manila, Philippines 1002 <br />
                </a>
                Direct Line: (+632) 8-524-3769, Trunk Line Number (+632)
                8-465-2400
                <br />
                <a
                  style={{
                    color: "white",
                    borderBottom: "1px solid #fff",
                  }}
                  href="https://immigration.gov.ph"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Bureau of Immigration
                </a>{" "}
                | immigPH@gmail.com | binoc_immigration@hotmail.ph <br />
                Copyright © {new Date().getFullYear()}. All Rights Reserved..
              </div>
            </div>
          </footer>
        </div>
      </>
    );
  }
}

export default withRouter(SignInPage);
